import React from "react"
import DynamicFormTypes from "src/pages/dynamic_forms/Types/DynamicFormsTypes"
import "./DynamicFormsContextMenu.css"

interface Props {
    manageParentState: Function
    manageGrandparentState: Function
    form: DynamicFormTypes
    index: number
    hints: boolean
    show: boolean
    flip: boolean
}

function DynamicFormsContextMenu(props: Props) {

    const canTaskOrRelease = props.form.CustomFormTypeId < 4

    const menuItems = [
        {
            title: "Release",
            stateManagerKeys: [{ key: "formToRelease", value: props.form }],
            hide: !canTaskOrRelease
        },
        {
            title: "Task",
            stateManagerKeys: [{ key: "formToTask", value: props.form }],
            hide: !canTaskOrRelease
        },
        {
            title: "Edit",
            stateManagerKeys: [{ key: "formToPreview", value: false }, { key: "formToEdit", value: props.form }],
            hide: false
        },
        {
            title: "Delete",
            stateManagerKeys: [{ key: "formToDelete", value: props.form }],
            hide: false
        }
    ]

    return (
        <div id={`dynamic-forms-table-context-menu-${props.index}`} className="DynamicFormsContextMenu">
            <div className="DynamicFormsContextMenuInactive">
                <span id={`dynamic-forms-table-context-menu-toggle-btn-${props.index}`} className="material-icons"
                    onMouseEnter={() => props.manageParentState([{ key: "stopRowPropagation", value: true }])}
                    onMouseLeave={() => props.manageParentState([{ key: "stopRowPropagation", value: false }])}
                    onClick={() => props.manageParentState([{ key: "showContextMenu" }])}>more_horiz</span>
            </div>
            {props.show && <div
                className={`DynamicFormsContextMenuMenu ${props.flip ? "DynamicFormsContextMenuMenuFlipped" : "DynamicFormsContextMenuMenuNotFlipped"}`}
                onMouseLeave={() => props.manageParentState([{ key: "showContextMenu" }, { key: "stopRowPropagation", value: false }])}
                onMouseEnter={() => props.manageParentState([{ key: "stopRowPropagation", value: true }])}
            >
                {menuItems.map((item, i: number) =>
                    <div
                        className={`DynamicFormsContextMenuMenuItem ${item.hide ? "DynamicFormsContextMenuMenuItemHide" : "DynamicFormsContextMenuMenuItemShow"}`}
                        key={`dynamic-forms-table-context-menu-item-${i}`}
                        onClick={() => props.manageGrandparentState(item.stateManagerKeys)}
                    >
                        <p>{item.title}</p>
                    </div>
                )}
            </div>}
        </div>
    )
}

export default DynamicFormsContextMenu